import { TbArrowNarrowRight } from "react-icons/tb";
import { Link } from "react-router-dom";
import Router from "../../const/router";
// Assets
import NotFoundImage from "../../assets/not-found.svg";
import "./index.scss";

const NotFound = () => {
  return (
    <section className="not-found">
      <img src={NotFoundImage} alt="Not found" />
      <div className="not-found-info">
        <h1>404</h1>
        <p className="not">not found</p>
        <hr />
        <Link to={Router.HOME} className="row">
          <p className="back">back to home</p>
          <div className="back-icon">
            <TbArrowNarrowRight />
          </div>
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
